// extracted by mini-css-extract-plugin
export default {"divspace":"index_divspace__NIY5y"};